var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.3334c.9665 0 1.75.7462 1.75 1.6666 0 .9205-.7835 1.6667-1.75 1.6667S.75 12.9205.75 12c0-.9204.7835-1.6666 1.75-1.6666zm0-5.00003c.9665 0 1.75.7462 1.75 1.66667 0 .92048-.7835 1.66667-1.75 1.66667S.75 7.92052.75 7.00004c0-.92047.7835-1.66667 1.75-1.66667zm0-4.999996c.9665 0 1.75.746196 1.75 1.666666 0 .92048-.7835 1.66667-1.75 1.66667S.75 2.92052.75 2.00004c0-.92047.7835-1.666666 1.75-1.666666z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.c2f6fafc.svg";
export { ForwardRef as ReactComponent };